import { render, staticRenderFns } from "./PendingProcessSteps.vue?vue&type=template&id=4d770aba&"
import script from "./PendingProcessSteps.vue?vue&type=script&lang=js&"
export * from "./PendingProcessSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports